import { Button, Form, Input, message } from "antd";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { requestApiGuestMail, requestApiValidateByGuest, requestApiValidateGuest } from "../../store/actions/actions";

import styles from "./endAccountByGuest.module.css";

const EndAccountByGuest = (props) => {
  const [finish, setFinish] = useState(false);

  useEffect(() => {
    document.title = `${props.t("endGuest.header")} - Wifi Guest`;
    let queryString = props.location.search;
    let urlParams = new URLSearchParams(queryString);
    if (!urlParams) {
      return <Redirect to={"/home"} />;
    } else if (sessionStorage.getItem("id") && sessionStorage.getItem("token")) {
      props.requestApiGuestMail({
        id: sessionStorage.getItem("id"),
        token: sessionStorage.getItem("token"),
      });
    } else {
      getQuery();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getQuery = () => {
    let queryString = props.location.search;
    let urlParams = new URLSearchParams(queryString);
    let id = urlParams.get("id");
    let token = urlParams.get("token");
    sessionStorage.setItem("id", id);
    sessionStorage.setItem("token", token);
    window.history.pushState("clear", "", "/confirm-account-guest");
    props.requestApiGuestMail({
      id: sessionStorage.getItem("id"),
      token: sessionStorage.getItem("token"),
    });
  };

  const callbackConfirmByGuest = (res) => {
    if (res) {
      message.success(<span style={{ marginLeft: "5px" }}>{props.t("endGuest.server.success")}</span>);
    } else {
      message.error(<span style={{ marginLeft: "5px" }}>{props.t("endGuest.server.error")}</span>);
    }
  };

  const confirmByGuest = (values) => {
    props.requestApiValidateGuest({
      id: sessionStorage.getItem("id"),
      token: sessionStorage.getItem("token"),
      body: {
        firstName: values.firstName,
        lastName: values.name,
        company: values.company,
        language: "fr",
      },
      callback: (e) => {
        callbackConfirmByGuest(e);
        props.requestApiValidateByGuest({
          id: sessionStorage.getItem("id"),
          token: sessionStorage.getItem("token"),
          callback: () => {
            setFinish(true);
          },
        });
      },
    });
  };

  const {
    data: { mail, validated },
    t,
  } = props;

  const defaultValues = {
    email: mail,
  };

  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(defaultValues);
  }, [form, defaultValues]);

  if (validated) {
    message.warn(<span style={{ marginLeft: "5px" }}>{t("endGuest.server.validated")}</span>);
    return <Redirect push to={"/home"} />;
  }
  if (finish) {
    return <Redirect push to={"/home"} />;
  }

  return (
    <div className={styles.form_container}>
      <h2>{t("endGuest.title")}</h2>
      <Form name="basic" initialValues={defaultValues} onFinish={confirmByGuest} autoComplete="off" layout="vertical" className={styles.form} form={form}>
        <div className={styles.form_flex}>
          <Form.Item
            label={t("endGuest.label.firstname")}
            name="firstName"
            className={styles.input_item}
            rules={[
              {
                required: true,
                message: t("endGuest.validation.firstname"),
              },
            ]}
          >
            <Input placeholder={t("endGuest.placeholder.firstname")} />
          </Form.Item>
          <Form.Item
            label={t("endGuest.label.lastname")}
            name="name"
            className={styles.input_item}
            rules={[
              {
                required: true,
                message: t("endGuest.validation.lastname"),
              },
            ]}
          >
            <Input placeholder={t("endGuest.placeholder.lastname")} />
          </Form.Item>
        </div>

        <Form.Item
          label={t("endGuest.label.mail")}
          name="email"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: t("endGuest.validation.mail"),
              type: "email",
            },
          ]}
        >
          <Input disabled={mail ? true : false} placeholder={t("endGuest.placeholder.mail")} />
        </Form.Item>

        <Form.Item
          label="Entreprise"
          name="company"
          rules={[
            {
              required: true,
              message: t("endGuest.validation.company"),
            },
          ]}
        >
          <Input placeholder={t("endGuest.placeholder.company")} />
        </Form.Item>
        <div className={styles.form_footer}>
          <div className={styles.form_footer_mandatory}>
            <p> {t("endGuest.label.mandatory")}</p>
          </div>
          <div className={styles.form_button}>
            <Form.Item>
              <Link to="/home-sso">
                <Button danger size="large">
                  {t("endGuest.button.cancel")}
                </Button>
              </Link>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" size="large">
                {t("endGuest.button.continue")}
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestApiGuestMail,
      requestApiValidateByGuest,
      requestApiValidateGuest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EndAccountByGuest));
